import { render, staticRenderFns } from "./courseNote.vue?vue&type=template&id=77f87808&scoped=true&"
import script from "./courseNote.vue?vue&type=script&lang=js&"
export * from "./courseNote.vue?vue&type=script&lang=js&"
import style0 from "./courseNote.vue?vue&type=style&index=0&id=77f87808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f87808",
  null
  
)

export default component.exports